module.exports = __webpack_public_path__ + "img/hero-dropdown-search-lincoln.b2749001.png";